import { register as registerSwiperElemets } from "swiper/element/bundle";
import "swiper/element/css/effect-fade";
import { SwiperInstances } from "./../modules/_SwiperInstances"

registerSwiperElemets(); //This registers Swiper's custom HTML elements

window.swiperInstances = new SwiperInstances();
